module.exports = {
  txt_0001: 'Join in Edmodo for free',
  txt_0002: 'Login',
  txt_0003: 'Feedback',
  txt_0004: 'Preview',
  txt_0005: 'View More',
  txt_0006: 'Download',
  txt_0007: 'User Guide',
  txt_0008: 'Comments',
  txt_0009: 'Submit',
  txt_0010: 'All',
  txt_0011: 'Good',
  txt_0012: 'Fair',
  txt_0013: 'Poor',
  txt_0014: 'First',
  txt_0015: 'Last',
  txt_0016: 'Next',
  txt_0017: 'Prev',
  txt_0018: 'Version',
  txt_0019: 'COMING SOON',
  txt_0020: 'pick up',
  txt_0021: 'Help and Feedback',
  txt_0022: 'Privacy',
  txt_0023: 'Terms of Service',
  txt_0024: 'Search in edmodo labs',
  txt_0025: 'Try Now',
  txt_0026: 'Maximum 1024 characters are allowed.',
  txt_0027: 'Loading...',
  txt_0028: 'Network error.',
  txt_0029: 'Please try again later.',
  txt_0030: 'Please try again',
  txt_0031: 'You can leave comments after login.',
  txt_0032: 'Click to',
  txt_0033: 'or',
  txt_0034: 'Sign Up',
  txt_0035: 'Stay tuned for updates',
  txt_0036: 'Comment cannot be empty.',

  txt_0037: 'Edmodo is a global education network that helps connect all learners with the people and resources needed to reach their full potential.',
  txt_0038: 'Edmodo',

  txt_0039: 'Company',
  txt_0040: 'About',
  txt_0041: 'Careers',
  txt_0042: 'Privacy',
  txt_0043: 'Terms Of Service',
  txt_0044: 'Contact Us',

  txt_0045: 'Learn More',
  txt_0046: 'Teachers',
  txt_0047: 'Students',
  txt_0048: 'Parents',
  txt_0049: 'Schools',

  txt_0050: 'Resources',
  txt_0051: 'Spotlight',
  txt_0052: 'Blog',
  txt_0053: 'Support',

  txt_0054: 'Connect',
  txt_0055: 'Twitter',
  txt_0056: 'Facebook',
  txt_0057: 'Switch Account',
  txt_0058: 'Logout',

  txt_0059: 'Edmodo Labs Tools',
  txt_0060: 'Get innovative! You might discover your new favorite learning tool.',
  txt_0061: 'More tools coming soon.',
  txt_0062: "We'll be releasing more soon. Follow Edmodo Labs on Edmodo to stay updated on the latest releases!",
  txt_0063: 'Follow Edmodo Labs',
  txt_0064: 'Help create the next generation of edtech tools! At Edmodo Labs, you’ll be among the first to experience emerging edtech tools and software.',
  txt_0065: "What's New",
  txt_0066: 'Innovating technology with you. ',
  txt_0067: 'Your feedback matters',
  txt_0068: 'We want to build technology that transforms the way you teach and learn. That’s why we need your feedback to help us build better tools. Send us your thoughts and opinions on our latest Edmodo Labs app. ',
  txt_0069: 'Share feedback',
  txt_0070: 'View All',

  txt_0071: 'I’m a Teacher',
  txt_0072: 'I’m a Student',
  txt_0073: 'I’m a Parent',
  txt_0074: 'Coming Soon',

  txt_0075: "What's New",
  txt_0076: 'Version History',
  txt_0077: 'Version',
  txt_0078: 'Update Time',
  txt_0079: 'Version Description',
  txt_0080: 'Information',
  txt_0081: 'Size',
  txt_0082: 'Compatibility',
  txt_0083: 'Languages',
  txt_0084: 'Tags',
  txt_0085: 'Error: The application is currently unavailable.',

  txt_0086: 'Choose Language',
  txt_0087: 'Enter keywords',
  txt_0088: 'No results',
  txt_0089: 'There are no results that match your search.',
  txt_0090: 'results',
  txt_0091: 'Download on PC only'
}



// WEBPACK FOOTER //
// ./src/i18n/en.js